module.exports = __webpack_public_path__ + "static/media/logo.8e251882.png";